import React from "react";
import { Chart } from "react-google-charts";
import "../GeographyChart/GeographyChart.css";

// Define the new data as an array of objects
export const data = [
  { country: "Germany", exchange: 255, user: 620 },
  { country: "United States", exchange: 310, user: 300 },
  { country: "Brazil", exchange: 369, user: 400 },
  { country: "Canada", exchange: 430, user: 500 },
  { country: "France", exchange: 590, user: 600 },
  { country: "Russia", exchange: 720, user: 700 },
];

const GeographyChart = () => {
  // Transform the data for Google Charts
  const chartData = [
    ["Country", "Exchange", { role: "tooltip", type: "string" }],
  ];
  data.forEach((item) => {
    const tooltipContent = `Exchange: ${item.exchange}\nUsers: ${item.user}`;
    chartData.push([item.country, item.exchange, tooltipContent]);
  });

  // Handle 'select' event
  const handleSelectEvent = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();

    if (selection.length === 0) return;

    const selectedRegion = chartData[selection[0].row + 1];
    console.log("Selected : " + selectedRegion[0]); // Access the country name (selectedRegion[0])
  };

  return (
    <>
      <section className="section">
        <div className="geo-container">
          <div className="geo-header">
            <h1>
              Global Report : Exchange and User Statistics by
              Country <sub style={{color: "blue"}}>(World map chart)</sub>
            </h1>
          </div>

          <div className="geo-parent">
            <div className="count-wrapper">
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#fdcc71" }}
                ></i>{" "}
                Exchange
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#fdcc71" }}
                ></i>{" "}
                User
              </div>
            </div>

            <div className="geo-chart-container">
              <Chart
                chartType="GeoChart"
                data={chartData} // Use transformed data
                height={300}
                chartEvents={[
                  {
                    eventName: "select",
                    callback: handleSelectEvent,
                  },
                ]}
                options={{
                  tooltip: { isHtml: false }, // Use text-based tooltips
                  colors: ["#fdcc71"], // Set the region color
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GeographyChart;
